import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { DataSourceListActions } from './data-source-list.store';
import { ViewsHttpService } from '../../services/views-http.service';

@Injectable({ providedIn: 'root' })
export class DataSourceListEffects {
  private readonly actions$ = inject(Actions);
  private readonly viewsHttpService = inject(ViewsHttpService);

  public effect = createEffectFactory(DataSourceListActions, this.actions$);

  public createOne$ = this.effect(DataSourceListActions.fetch, () =>
    this.viewsHttpService.listDataSources(),
  );
}
